<template>
    <div class="" style="width: 100%">
        <v-file-input
            v-model="pdfs"
            small-chips
            counter
            multiple
            show-size
            truncate-length="15"
            accept="application/pdf"
            label="Wählen Sie bis zu 3 PDF aus"
            prepend-icon="mdi-file-pdf"
            @change="onFileChange"
        ></v-file-input>

        <div class="error-message">
            {{ errorMessage }}
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pdfs: [],
            maxPdfs: 3,
            errorMessage: ""
        };
    },
    methods: {
        onFileChange(e) {
            this.errorMessage = "";
            if (this.pdfs.length <= this.maxPdfs) {

                let tooBig = false;
                e.forEach((value,index) => {
                    //console.log("fileinfo", value);
                    if (value.size > (2*1024*1024)) {
                        tooBig = true;
                    }
                });

                if (!tooBig) {
                    // amount and sizes ok
                    this.$emit("input", this.pdfs);
                } else {
                    this.errorMessage =
                        "Ein PDF darf nicht größer als 2MB sein.";
                }
            } else {
                this.errorMessage =
                    "Bitte maximal 3 PDF auswählen!";
            }
        }
    }
};
</script>
